/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { PaymentsServiceSwitchQuoteInvoiceAdjustmentType } from "./PaymentsServiceSwitchQuoteInvoiceAdjustmentType";
import {
  PaymentsServiceSwitchQuoteInvoiceAdjustmentTypeFromJSON,
  PaymentsServiceSwitchQuoteInvoiceAdjustmentTypeFromJSONTyped,
  PaymentsServiceSwitchQuoteInvoiceAdjustmentTypeToJSON,
  PaymentsServiceSwitchQuoteInvoiceAdjustmentTypeToJSONTyped,
} from "./PaymentsServiceSwitchQuoteInvoiceAdjustmentType";

/**
 *
 * @export
 * @interface PaymentsServiceSwitchQuotePaymentPlan
 */
export interface PaymentsServiceSwitchQuotePaymentPlan {
  /**
   *
   * @type {string}
   * @memberof PaymentsServiceSwitchQuotePaymentPlan
   */
  shipmentId: string;
  /**
   *
   * @type {string}
   * @memberof PaymentsServiceSwitchQuotePaymentPlan
   */
  originalQuoteId: string;
  /**
   *
   * @type {string}
   * @memberof PaymentsServiceSwitchQuotePaymentPlan
   */
  newQuoteId: string;
  /**
   *
   * @type {string}
   * @memberof PaymentsServiceSwitchQuotePaymentPlan
   */
  newCarrierDisplayName: string;
  /**
   *
   * @type {boolean}
   * @memberof PaymentsServiceSwitchQuotePaymentPlan
   */
  canSuccessfullyHandle: boolean;
  /**
   *
   * @type {string}
   * @memberof PaymentsServiceSwitchQuotePaymentPlan
   */
  message: string;
  /**
   *
   * @type {PaymentsServiceSwitchQuoteInvoiceAdjustmentType}
   * @memberof PaymentsServiceSwitchQuotePaymentPlan
   */
  invoiceAdjustmentType: PaymentsServiceSwitchQuoteInvoiceAdjustmentType;
  /**
   *
   * @type {number}
   * @memberof PaymentsServiceSwitchQuotePaymentPlan
   */
  amount?: number | null;
  /**
   *
   * @type {string}
   * @memberof PaymentsServiceSwitchQuotePaymentPlan
   */
  shipmentInvoiceId?: string | null;
}

/**
 * Check if a given object implements the PaymentsServiceSwitchQuotePaymentPlan interface.
 */
export function instanceOfPaymentsServiceSwitchQuotePaymentPlan(
  value: object,
): value is PaymentsServiceSwitchQuotePaymentPlan {
  if (!("shipmentId" in value) || value["shipmentId"] === undefined)
    return false;
  if (!("originalQuoteId" in value) || value["originalQuoteId"] === undefined)
    return false;
  if (!("newQuoteId" in value) || value["newQuoteId"] === undefined)
    return false;
  if (
    !("newCarrierDisplayName" in value) ||
    value["newCarrierDisplayName"] === undefined
  )
    return false;
  if (
    !("canSuccessfullyHandle" in value) ||
    value["canSuccessfullyHandle"] === undefined
  )
    return false;
  if (!("message" in value) || value["message"] === undefined) return false;
  if (
    !("invoiceAdjustmentType" in value) ||
    value["invoiceAdjustmentType"] === undefined
  )
    return false;
  return true;
}

export function PaymentsServiceSwitchQuotePaymentPlanFromJSON(
  json: any,
): PaymentsServiceSwitchQuotePaymentPlan {
  return PaymentsServiceSwitchQuotePaymentPlanFromJSONTyped(json, false);
}

export function PaymentsServiceSwitchQuotePaymentPlanFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaymentsServiceSwitchQuotePaymentPlan {
  if (json == null) {
    return json;
  }
  return {
    shipmentId: json["shipmentId"],
    originalQuoteId: json["originalQuoteId"],
    newQuoteId: json["newQuoteId"],
    newCarrierDisplayName: json["newCarrierDisplayName"],
    canSuccessfullyHandle: json["canSuccessfullyHandle"],
    message: json["message"],
    invoiceAdjustmentType:
      PaymentsServiceSwitchQuoteInvoiceAdjustmentTypeFromJSON(
        json["invoiceAdjustmentType"],
      ),
    amount: json["amount"] == null ? undefined : json["amount"],
    shipmentInvoiceId:
      json["shipmentInvoiceId"] == null ? undefined : json["shipmentInvoiceId"],
  };
}

export function PaymentsServiceSwitchQuotePaymentPlanToJSON(
  json: any,
): PaymentsServiceSwitchQuotePaymentPlan {
  return PaymentsServiceSwitchQuotePaymentPlanToJSONTyped(json, false);
}

export function PaymentsServiceSwitchQuotePaymentPlanToJSONTyped(
  value?: PaymentsServiceSwitchQuotePaymentPlan | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentId: value["shipmentId"],
    originalQuoteId: value["originalQuoteId"],
    newQuoteId: value["newQuoteId"],
    newCarrierDisplayName: value["newCarrierDisplayName"],
    canSuccessfullyHandle: value["canSuccessfullyHandle"],
    message: value["message"],
    invoiceAdjustmentType:
      PaymentsServiceSwitchQuoteInvoiceAdjustmentTypeToJSON(
        value["invoiceAdjustmentType"],
      ),
    amount: value["amount"],
    shipmentInvoiceId: value["shipmentInvoiceId"],
  };
}
